import React, { Component } from 'react';
import { Icons } from '../../utilities';
import { connect } from 'react-redux';
import * as sideBarActions from '../../redux/sideBarActions';
import * as fabricCanvasActions from '../../redux/fabricCanvasActions';
import * as modalActions from '../../redux/modalActions';
import { bindActionCreators } from 'redux';
import { string } from '../../localization';
import './UploadDialogue.scss';
import { Form } from 'reactstrap';
import * as Constants from '../../utilities/constants/Constants';
import * as signageHelperFunctions from '../../utilities/HelperFunctions/SignageHelperFunctions';

class UploadDialogue extends Component {
  state = {
    checkedIn: false,
    DATA: [],
    userPhotoUploadType: ''
  };

  componentWillMount() {
    const { dispatchers } = this.props;
    dispatchers.sideBarActions.showLoadingIcon(false);
  }

  componentDidMount() {
    const { isUploadLogo, dispatchers } = this.props;

    const uploadOptions = [];
    if (isUploadLogo) {
      uploadOptions.push({
        key: 1,
        name: string.BACKGROUND_UPPER_CASE_KEY,
        imageURL: Icons.background,
        type: Constants.USER_PHOTO_SCENE_TYPE
      });
    } else {
      if (dispatchers.modalActions.isPhotoSupported()) {
        uploadOptions.push({
          key: 3,
          name: string.PHOTOS_KEY,
          imageURL: Icons.photos,
          type: Constants.USER_PHOTO_ELEMENT_TYPE
        });
      }
      if (dispatchers.modalActions.isBackgroundSupported()) {
        uploadOptions.push({
          key: 1,
          name: string.BACKGROUND_UPPER_CASE_KEY,
          imageURL: Icons.background,
          type: Constants.USER_PHOTO_SCENE_TYPE
        });
      }
      if (dispatchers.modalActions.isObjectSupported()) {
        uploadOptions.push({
          key: 2,
          name: string.OBJECTS_UPPER_CASE_KEY,
          imageURL: Icons.objects,
          type: Constants.USER_PHOTO_ELEMENT_TYPE
        });
      }
    }
    this.setState({ DATA: uploadOptions });
    if (uploadOptions.length > 0) {
      this.changeUserPhotoUploadType(uploadOptions[0].name);
      dispatchers.sideBarActions.setUserPhotoUploadType(
        uploadOptions[0].name,
        uploadOptions[0].type
      );
    }
  }

  handleCheck = () => {
    const { checkedIn } = this.state;
    this.setState({ checkedIn: !checkedIn });
  };

  changeUserPhotoUploadType = name => {
    this.setState({
      userPhotoUploadType: name
    });
  };

  handleUserPhotoUploadType = item => {
    const { dispatchers } = this.props;

    this.changeUserPhotoUploadType(item.name);
    dispatchers.sideBarActions.setUserPhotoUploadType(item.name, item.type);
  };

  openTermsofUse = () => {
    const { dispatchers } = this.props;
    if (dispatchers.signageHelperFunctions.isFranceAccount()) {
      window.open(Constants.TERMS_AND_CONDITIONS_FRANCE);
    } else {
      window.open(Constants.TERMS_OF_SERVICE);
    }
  };

  getUploadTypeErrorString = () => {
    const { uploadError } = this.props;

    let errorString;
    switch (uploadError) {
      case Constants.UNSUPPORTED_FILE_TYPE_ERROR:
        errorString = string.INVALID_FILETYPE_ERROR_TEXT;
        break;
      case Constants.ENCRYPTED_PDF_ERROR:
        errorString = string.ENCRYPTED_PDF_NOT_SUPPORTED_TEXT;
        break;
      case Constants.UNSUPPORTED_FILE_SIZE_ERROR:
        errorString = string.INVALID_FILE_SIZE_ERROR_TEXT;
        break;
      case Constants.PROCESSING_FAILED:
        errorString = string.PROCESSING_FAILED;
        break;
      case Constants.MULTIPAGE_PDF_NOT_SUPPORTED_TEXT:
        errorString = string.MULTIPAGE_PDF_NOT_SUPPORTED_TEXT;
        break;
      case Constants.OPEN_PDF_ERROR:
        errorString = string.ERROR_IN_OPENING_PDF_FILE_TEXT;
        break;
      default:
        errorString = null;
        break;
    }
    return errorString;
  };

  render() {
    const {
      dispatchers,
      uploadedFile,
      isLoadingIcon,
      uploadStatus,
      uploadError,
      fileSize
    } = this.props;

    let processingStatus = null;

    if (uploadStatus && uploadStatus < Constants.MIN_UPLOAD_STATUS) {
      processingStatus = (
        <span className='processing-lbl'>
          {string.formatString(string.UPLOAD_STATUS, uploadStatus, fileSize)}
        </span>
      );
    } else if (uploadStatus != null) {
      processingStatus = (
        <span className='processing-lbl'>{string.PROCESSING_KEY}</span>
      );
    }
    const { checkedIn, DATA, userPhotoUploadType } = this.state;

    const uploadErrorType = this.getUploadTypeErrorString();
    return (
      <div className='Dailouge-box2-main-container Grey-text'>
        <div className='Dailouge-box2-header-conatiner '>
          <div className='upload-txt'>
            <img
              style={{ width: 29, height: 23, marginRight: 10 }}
              src={Icons.upload}
              alt='upload'
            />
            <h3 className='upload-head'>{string.UPLOAD_KEY}</h3>
          </div>

          {/* close button */}
          <div className='Dailouge-box2-termination-conatiner '>
            <button
              type='button'
              style={{
                width: 20,
                height: 20,
                border: 'none',
                background: 'none',
                outline: 'none'
              }}
              onClick={() =>
                dispatchers.sideBarActions.handleUploadDialogueState(false)
              }
            >
              <img src={Icons.closeDefault} alt='close' />
            </button>
            {/* <div className="Dailouge-box2-termination-overlay">
              <img
                style={{ width: 20, height: 20 }}
                src={Icons.closeHover}
                alt="close"
                onClick={e => dispatchers.sideBarActions.handleUploadDialogueState(
                  false
                )}
              />
            </div> */}
          </div>
        </div>

        {/* image description fields */}
        <div className='Dailouge-box2-description'>
          <h6>{string.PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY}</h6>
        </div>
        <div className='Dailouge-box2-selection-info'>
          <div className='d-flex upload-selected-file-container'>
            <p className='Light-grey-text'>
              <span className='selected-img-lbl'>
                {string.SELECTED_IMAGE_KEY}{' '}
              </span>
              <span className='Grey-text ml-2 selected-file-name'>
                {uploadedFile ? uploadedFile.name : null}
              </span>
            </p>
            {uploadErrorType != null ? (
              <div className='upload-btn-wrapper'>
                <div className='choose-file-label'>
                  {string.CHOOSE_FILE_KEY}
                </div>
                <input
                  type='file'
                  name='myfile'
                  onChange={dispatchers.sideBarActions.handleFileChange}
                />
              </div>
            ) : null}
          </div>
          {uploadErrorType != null ? (
            <span className='upload-error-text'>{uploadErrorType}</span>
          ) : null}

          <div className='Dailouge-box2-image-list-container'>
            {DATA.map(item => (
              <div key={item.key} className='Dailouge-box2-image-container'>
                <button
                  type='button'
                  className='Dailouge-box2-image'
                  onClick={() => this.handleUserPhotoUploadType(item)}
                  style={{ backgroundImage: `url(${item.imageURL})` }}
                >
                  <span>{item.name}</span>
                </button>
                <div className=''>
                  <input
                    type='radio'
                    id={item.imageURL}
                    name='imageSelector'
                    checked={item.name === userPhotoUploadType}
                    onChange={() => this.handleUserPhotoUploadType(item)}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        <p className='Dailouge-box2-check-line'>
          <div className='custom-control custom-checkbox'>
            <input
              type='checkbox'
              className='custom-control-input'
              id='customCheck1'
              checked={checkedIn}
              onChange={this.handleCheck}
            />
            <label htmlFor='customCheck1' className='custom-control-label'>
              <span>
                <span>{string.PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY}</span>
                <button
                  type='button'
                  className='terms-of-use'
                  style={{ outline: 'none' }}
                  onClick={this.openTermsofUse}
                >
                  {string.TERMS_OF_USE}
                </button>
              </span>
            </label>
          </div>
        </p>
        <div className='Dailouge-box2-button-container'>
          <Form
            className='text-left form-styles'
            onSubmit={dispatchers.sideBarActions.handleUploadSubmit}
          >
            {isLoadingIcon ? (
              <span className='loader-container'>
                <img
                  className='small'
                  src='data:image/gif;base64,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'
                  alt=''
                />
                {processingStatus}
              </span>
            ) : (
              <div />
            )}

            <button
              className={`Dailouge-box2-button btn ${
                !checkedIn || uploadError || isLoadingIcon
                  ? 'btn-disabled '
                  : 'btn-enabled '
              }${isLoadingIcon ? 'btn-label-color' : ''}`}
              ref={ref => {
                this.form = ref;
              }}
              style={{ height: 'inherit' }}
              type='submit'
              disabled={!checkedIn || uploadError || isLoadingIcon}
            >
              {string.UPLOAD_KEY}
            </button>
          </Form>
        </div>
      </div>
    );
  }
  // }
}

function mapStateToProps(state) {
  return {
    activeTab: state.sideBar.activeSideBarTab,
    uploadDialogueState: state.sideBar.uploadDialogue,
    isUploadLogo: state.sideBar.isUploadLogo,
    isLoadingIcon: state.sideBar.isLoadingIcon,
    uploadedFile: state.sideBar.upload.file,
    fileSize: state.sideBar.fileSize,
    uploadStatus: state.sideBar.uploadStatus,
    uploadError: state.sideBar.uploadErrorFlag,
    userPhotoType: state.sideBar.uploadInfo.userPhotoUploadType
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      modalActions: bindActionCreators(modalActions, dispatch),
      signageHelperFunctions: bindActionCreators(
        signageHelperFunctions,
        dispatch
      )
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadDialogue);
